import localeNl from '@angular/common/locales/nl';
import { EnvironmentInterface } from '@sk/sk-interfaces';

export const environment: EnvironmentInterface = {
  production: false,
  language: 'nl-NL',
  scheduleCheck: false,
  region: 'nl',
  locale: localeNl,
  firebase: {
    apiKey: 'AIzaSyBWXQXiCmM-E8hJZ-6PjCmGlvsKSMPyhWg',
    authDomain: 'joblog-nederland.firebaseapp.com',
    databaseURL: 'https://joblog-nederland.firebaseio.com',
    projectId: 'joblog-nederland',
    storageBucket: 'joblog-nederland.appspot.com',
    messagingSenderId: '373809780594',
    appId: '1:373809780594:web:1d2755e12baf00f67aafeb',
    measurementId: 'G-GDR6HF6R2J'
  },
  api_url: 'https://europe-west1-joblog-nederland.cloudfunctions.net',
  // api_url: 'http://localhost:5000/joblog-nederland/europe-west1',
  base_url: 'https://office.joblog24.nl/nl',
  releaseCompany: 'JobLog Nederland B.V.',
  release: 'nl_NL | 0.0.76'
};
